import VoucherTable from "./voucher-table";

export default function VoucherPage() {
  return (
    <div className="p-4 md:p-6 lg:p-8">
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-gray-900 md:text-2xl">
          Usage History
        </h1>
      </div>
      <VoucherTable />
    </div>
  );
}
